import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { InvoiceBorrowFormComponent } from "../../../components/borrowSystem/Invoice/InvoiceBorrowFormComponent";
// import { AdminCheckComponent } from "../../components/borrowSystem/AdminCheckComponent";
// import { AdminApproveBorrowFormComponent } from "../../components/borrowSystem/AdminApproveBorrowFormComponent";

import { Footer } from "../../../components/share/Footer";

export function InvoiceBorrowFormContainer() {
  const titleName = "จัดทำหนังสือแจ้งหนี้";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <InvoiceBorrowFormComponent />
      <Footer />
    </div>
  );
}
